import React, { useEffect, useState } from "react";
// import { TypeAnimation } from 'react-type-animation';
import { ReactComponent as CrossIcon } from "../assets/Cros.svg";
import { Collapse, Tooltip } from "@mui/material";

import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { getItem, setItem } from "../utils/DataProtection";
import { useDispatch } from "react-redux";
import { config_UPTIME } from "../Constants";

const API_URL = config_UPTIME.url.API_URL + "/userinfo/update";


export default function ScopeHeader({
  bgImage,
  bgColor,
  linearGradient,
  txtColor,
  title,
  description,
  id,
  dataTestId,
}) {
  const [hideActionCompleted, setHideActionCompleted] = useState(false);

  // Initialize visibility based on persistence
  const [isVisible, setIsVisible] = useState(false);
  const [isFullyRemoved, setIsFullyRemoved] = useState(false);

  let section = title || "DefaultSection";

  const dispatch = useDispatch();

  const persisted = getItem("persisted_content_configurations");
  const userId = JSON.parse(getItem("userid"));
  const userInfo = JSON.parse(getItem("userinfo"));

  const activeConfig = persisted
    ? JSON.parse(persisted)
    : userInfo?.contentconfigurations;

  const userNodeId = JSON.parse(getItem("usernodeid"));

  useEffect(() => {
    const persisted = getItem("persisted_content_configurations");
    const userInfo = JSON.parse(getItem("userinfo"));
    const activeConfig = persisted
      ? JSON.parse(persisted)
      : userInfo?.contentconfigurations;
    const userNodeId = JSON.parse(getItem("usernodeid"));
    const visibilityList = activeConfig?.visibilitySettings?.[userNodeId] || [];

    const hidden = visibilityList.some(
      (itm) =>
        itm.feature === "ScopeHeader" &&
        itm.section === section &&
        itm.type === "Hidden",
    );

    if (hidden) {
      setIsFullyRemoved(true);
    } else {
      setIsVisible(true);
    }
  }, [section]);

  const handleHide = async () => {

    setIsVisible(false);
    
    try {
      let fullConfig = persisted
        ? JSON.parse(persisted)
        : { ...userInfo?.contentconfigurations };

      if (!fullConfig.visibilitySettings) fullConfig.visibilitySettings = {};
      if (!fullConfig.visibilitySettings[userNodeId])
        fullConfig.visibilitySettings[userNodeId] = [];

      // Add the hidden state to the list
      fullConfig.visibilitySettings[userNodeId].push({
        feature: "ScopeHeader",
        type: "Hidden",
        section: section,
      });

      // Update Local Storage immediately for "instant" UI update
      setItem("persisted_content_configurations", JSON.stringify(fullConfig));

      // Sync with full userinfo
      const storedUserInfo = getItem("userinfo");
      if (storedUserInfo) {
        const fullUserInfo = JSON.parse(storedUserInfo);
        fullUserInfo.contentconfigurations = fullConfig;
        setItem("userinfo", JSON.stringify(fullUserInfo));
      }

      // API Call
      const user_token = getItem("user");
      await axios
        .post(
          API_URL,
          {
            userid: userId,
            userinfo: { contentConfigurations: fullConfig },
          },
          {
            headers: { Authorization: "Bearer " + JSON.parse(user_token) },
          },
        )
        .then(() => {
          // DISPATCH THE ALERT
          dispatch({
            type: "SHOW_SNACKBAR",
            payload: {
              open: true,
              title: "Erfolg",
              description: `Hinweis wurde erfolgreich ausgeblendet.`,
              severity: "success",
            },
          });
        });

      setHideActionCompleted(true);

      setItem("persisted_content_configurations", JSON.stringify(fullConfig));

      setItem("userinfo", JSON.stringify(fullConfig));
    } catch (err) {
      console.error("Failed to hide banner", err);
    }
  };

  // If hidden, return null so it doesn't render
  //   if (isHidden || hideActionCompleted) return null;

  return (
    <Collapse
      in={isVisible}
      timeout={500}
      onExited={() => setIsFullyRemoved(true)} // Unmount from DOM after animation
    >
      <div
        className="bannerWrapper"
        style={{
          background: `url(${bgImage}) , 
        linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), 
        ${bgColor}`,
          backgroundColor: bgColor,
          color: txtColor,
        }}
        id={id}
        data-testid={dataTestId}
      >
        <div className="crossIcon">
          <Tooltip title="Hinweis ausblenden">
            <CrossIcon onClick={handleHide} />
          </Tooltip>
        </div>
        <div className="title">{title}</div>
        <div className="description">
          {/* <TypeAnimation
                    sequence={[
                        description,
                        1000,
                    ]}
                    speed={80}
                /> */}
          {description}
        </div>
      </div>
    </Collapse>
  );
}
